import { Grid, makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React, { Dispatch, SetStateAction } from 'react';
import BarsList from '../../components/BarsList/BarsList.component';
import CustomersList from '../../components/CustomersList/CustomersList.component';
import PageContainer from '../../components/PageContainer/PageContainer.component';
import HappyHourAdmin from '../../components/HappyHourAdmin/HappyHourAdmin.component';
import AppSideMenuComponent from '../../components/SideMenu/SideMenu.component';
import { IBar } from '../../models/IBars';
import { ICustomer } from '../../models/ICustomers';
import { SideMenuItem } from '../../models/INav';

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
            padding: theme.spacing(3),
        },
        searchBar: {
            marginBottom: theme.spacing(3),
            [theme.breakpoints.down('sm')]: {
                marginBottom: 0,
            },
            [theme.breakpoints.up('md')]: {
                marginBottom: theme.spacing(1),
            },
        },
        input: {
            backgroundColor: '#fff',
        }
    }),
);

interface Props {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    barSearchValue: string
    setBarSearchValue: Dispatch<SetStateAction<string>>
    cusSearchValue: string
    setCusSearchValue: Dispatch<SetStateAction<string>>
    bars: any[]
    customers: any[]
    view: string
    navItems: SideMenuItem[]
    onCreateClick: () => void
    onDetailsClick: (entry: IBar & ICustomer) => void
    onDeleteBarClick: (entry: IBar) => void,
    onDeleteCustomerClick: (cus: ICustomer) => void
}

export default function DashboardPage({
    open,
    setOpen,
    barSearchValue,
    setBarSearchValue,
    cusSearchValue,
    setCusSearchValue,
    bars,
    customers,
    view,
    navItems,
    onCreateClick,
    onDetailsClick,
    onDeleteCustomerClick,
    onDeleteBarClick
}: Props) {
    const classes = useStyles();

    return (
        <div>
            <AppSideMenuComponent
                open={open}
                setOpen={setOpen}
                navItems={navItems}
            >
                <PageContainer>
                    <Grid container spacing={3} className={classes.root}>
                        {
                            view === "bars" ? (
                                <BarsList
                                    data={bars}
                                    searchValue={barSearchValue}
                                    setSearchValue={setBarSearchValue}
                                    onCreateClick={onCreateClick}
                                    onDetailsClick={onDetailsClick}
                                    onDeleteClick={onDeleteBarClick}
                                />
                            ) : view === "customers" ? (
                                <CustomersList
                                    searchValue={cusSearchValue}
                                    setSearchValue={setCusSearchValue}
                                    data={customers}
                                    onDetailsClick={onDetailsClick}
                                    onDeleteClick={onDeleteCustomerClick}
                                />
                            ) : (
                                <HappyHourAdmin />
                            )
                        }
                    </Grid>
                </PageContainer>
            </AppSideMenuComponent>
        </div>
    )
}
